// components/PopperContainer.js
import { createPortal } from "react-dom";

const PopperContainer = ({ children }) => {
  return typeof document !== "undefined"
    ? createPortal(children, document.body)
    : null;
};

export default PopperContainer;
